/**
 * Output Restricted Media Key Status.
 *
 * @group DRM
 *
 * @beta
 */
export const OUTPUT_RESTRICTED = 'output-restricted';
//# sourceMappingURL=OUTPUT_RESTRICTED.js.map